import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';
import { CommonLayoutComponent } from './layouts/common-layout/common-layout.component';
import { Login1Component } from './modules/authentication/login-1/login-1.component';
import { authGuard } from './shared/guard/auth.guard';
import { FullLayoutComponent } from './layouts/full-layout/full-layout.component';
import { homeAuthGuardGuard } from './shared/guard/home-auth-guard.guard';
import { ErrorPageComponent } from './pages/error-page/error-page.component';

const appRoutes: Routes = [
  {
    path: 'auth',
    component: FullLayoutComponent,
    canActivate: [homeAuthGuardGuard],
    loadChildren: () =>
      import('./modules/authentication/authentication.module').then(
        (m) => m.AuthenticationModule
      ),
  },
  {
    path: 'dashboard',
    component: CommonLayoutComponent,
    canActivate: [authGuard],
    data: {
      permissions: {
        only: ['admin', 'root'],
        redirectTo: 'auth/login',
      },
    },
    loadChildren: () =>
      import('./modules/dashboard/dashboard.module').then(
        (m) => m.DashboardModule
      ),
  },
  { path: '', redirectTo: 'auth', pathMatch: 'full' },
  {
    path: '**',
    component: ErrorPageComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {
      // preloadingStrategy: PreloadAllModules,
      anchorScrolling: 'enabled',
      scrollPositionRestoration: 'enabled',
      useHash: true,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
